import { MainCard } from './MainCard';

import { ReactNode } from 'react';

interface ShadowBoxProps {
  shadow: string;
  children: ReactNode;
}

function ShadowBox({ shadow, children, ...props }: ShadowBoxProps) {
  return (
    <MainCard content={false} border={false} shadow={shadow} boxShadow {...props}>
      {children}
    </MainCard>
  );
}

export { ShadowBox };
